import { BasicButton } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

interface Props {
  onPress: () => void;
}
export function CreateAPIKeyButton(props: Props) {
  const { t } = useTranslation();
  return (
    <BasicButton onPress={props.onPress} testID="create-api-key">
      {t("Create API key")}
    </BasicButton>
  );
}
